import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Spinner, Col, Row, Container } from 'reactstrap';
import { getSelectedTrainer } from '../../store/trainers/selectors';
import { ITrainerProfile } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import DetailForm from './detailForm';
import BlobUtil from '../../utils/blobUtil'

import { 
    listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/trainers/actions';

import { getSelectedOrganiserById } from '../../store/organisers/selectors';
import { 
    listRequest as listOrganiserRequestAction,
    updateRequest as updateOrganiserRequestAction 
} from '../../store/organisers/actions';

import OrganiserTopNav from '../../components/organiserTopNav';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    organiserData : any
    ui : any
}

interface IState {
    isNew: boolean
    modalOverwriteWarning: boolean
    loaded : boolean
    RegisterFaceImgList : any []
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
    listOrganiserRequest : typeof listOrganiserRequestAction
    updateOrganiserRequest : typeof updateOrganiserRequestAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class TrainerDetailPage extends React.Component<AllProps, IState> {
    blobUtil: BlobUtil;

    constructor(props: AllProps) {
        super(props);
        this.state = {
            modalOverwriteWarning : false,
            isNew : false,
            loaded : false, 
            RegisterFaceImgList : []
        };
        this.blobUtil = new BlobUtil();
        this.readData = this.readData.bind(this);
        this.readOrganiserData = this.readOrganiserData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.handleOverwriteWarning = this.handleOverwriteWarning.bind(this);
        this.getPicPath = this.getPicPath.bind(this);
        this.getImgURL = this.getImgURL.bind(this);
    }

    public componentDidMount() {
        let organiserId = this.props.route.match.params.organiserId; // Organiser Id
        let trainerId = this.props.route.match.params.trainerId; // Trainer Id
        if (trainerId.toUpperCase() === "NEW"){
            this.setState({isNew: true});
        }else{
            this.props.selectData(trainerId);
        }

        if (this.props.route.match.params.organiserId != undefined && this.props.organiserData === undefined){
            this.readOrganiserData();
        }
    }
    public componentWillUnmount() {
        this.props.selectedClear();  
    } 

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["period"] = Number(parsed.pk);
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    readOrganiserData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.route.match.params.organiserId;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listOrganiserRequest(searchParams);
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }
        // Load data to state for chanages
        if (this.props.ui.processState !== 3 && this.props.data !== undefined && !this.state.loaded){
                this.setState({ loaded : true}, () => {
                    this.props.selectedData();
    
                    this.getImgURL().then(imgList=> {
                        this.setState({ RegisterFaceImgList : imgList});
                        console.log(imgList);
                    })
                })
        }
        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                if (this.state.isNew){ // Added successfully
                    this.setState({isNew: false});
                    this.props.route.history.push('/organisers/' + this.props.route.match.params.organiserId + "/trainers/" + this.props.data.id);

                    //For New Trainer Update Organization Profile.
                    this.UpdateOrganiser(this.props.data.id, this.props.data, this.props.data.profession, false);
                }
                notification.show = true;
                notification.type = "success";
                notification.message = "Save successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                if (this.props.ui.isConflict){
                    this.setState({ modalOverwriteWarning : true});
                } else {
                    this.setState({ modalOverwriteWarning : false});

                    notification.show = true;
                    notification.type = "danger";
                    notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
                }
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
                
            // Call Remove trainer from Organiser list
            this.UpdateOrganiser(this.props.ui.selected, undefined, [], true);

            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
    handleSelectValue = (selectedValue: any) => {
        let val: any = []
        if(selectedValue) {
            selectedValue.forEach((element:any) => {
                val.push(element.label);
            });
        }
        return val;
    }
   
    createOrUpdateData = async (formData:any) => {
        if (this.state.isNew){
            const n:ITrainerProfile ={
                id : "",
                organiserId : this.props.route.match.params.organiserId,
                name : formData.name,
                profile : formData.profile,
                profileImgURL : formData.profileImgURL,
                profession : this.handleSelectValue(formData.profession),
                searchKeywords : formData.name.toLowerCase()
            }

            this.props.createRequest(n);
        } else {
            let overwriteFlag = formData.Overwrite === "true"? true:false;

            this.props.updateRequest({
                id : this.props.ui.selected,
                name : formData.name,
                profile : formData.profile,
                profileImgURL : formData.profileImgURL,
                profession : this.handleSelectValue(formData.profession),
                overwrite : overwriteFlag,
                searchKeywords : formData.name.toLowerCase(),
                _etag : this.props.data._etag,
            });

            this.UpdateOrganiser(this.props.ui.selected, formData, this.handleSelectValue(formData.profession), false);

            if (overwriteFlag === true){
                this.handleOverwriteWarning(); // Trigger close warning modal dialog
            }
        }

    }

    UpdateOrganiser(trainerId : string, d: any, professionList:[], isRemove : boolean){
        // Update Organisers
        let trainers = this.props.organiserData?.trainers;
        trainers = trainers.filter((t:any) => {
            return t.id !== trainerId; // Remove and add again
        });

        if (!isRemove){
            trainers.push({
                id: trainerId,
                name : d.name,
                profile : d.profile,
                profileImgURL : d.profileImgURL,
                profession : professionList
            });
        }
        
        this.props.updateOrganiserRequest(
            {
                id : this.props.route.match.params.organiserId,
                trainers : trainers
            }
        );

    }

    deleteData = async (doc:ITrainerProfile) => {
        this.props.deleteRequest(doc);
    }
    
    handleOverwriteWarning(){
        this.setState({modalOverwriteWarning : !this.state.modalOverwriteWarning});
    }
    
    getImgURL = async () => {
        console.log("Call Get face imagess");
        if (this.props.data?.faceImageList){
            return Promise.all(
                this.props.data?.faceImageList.map((fileName: string) => { 
                    console.log(fileName);
                    return this.getPicPath(fileName) })
            );
        }else{
            return [];
        }
    }
    async getPicPath(fileName: string) {
        let imgUrl = "";
        imgUrl = await this.blobUtil.GetBlob(this.props.route.match.params.id, fileName);
        return imgUrl;
    }

    public render() {
        return (
            <div className="bg-light container">
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <React.Fragment>
                            <OrganiserTopNav activeTab = "Trainers" organiserId ={this.props.route.match.params.organiserId} />

                            <DetailForm 
                                props = {this.props} 
                                organiserId = {this.props.route.match.params.organiserId}
                                read = {this.readData}
                                save = {this.createOrUpdateData}
                                remove = {this.deleteData}
                                overwriteWarningFlag = {this.state.modalOverwriteWarning}
                                overwriteHandleWarning = {this.handleOverwriteWarning}
                                isNew = {this.state.isNew}
                            />

                            {/* {
                                JSON.stringify(this.props.organiserData)
                            } */}
                        </React.Fragment>
                    )
                }
                
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState, ownProps:any) => ({
    ui: state.trainer.ui,
    data: getSelectedTrainer(state),
    organiserData : getSelectedOrganiserById(state, ownProps.route.match.params.organiserId)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction,
    updateOrganiserRequest : updateOrganiserRequestAction,
    listOrganiserRequest : listOrganiserRequestAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrainerDetailPage)
